import React, {useEffect, useState} from 'react';
import './TypePrintSadanShop.scss';
import DynaTable from "../../MyTable/DynaTable";
import numericFunction from "../../../utils/NumericFunction";
import commaSeparator from "../../../utils/CommaSeparator";

const PrintFactorBuySadan = (props) => {
debugger
  const componentData = props.data.data
  const [myColumn, setMyColumn] = useState([])
  const [myData, setMyData] = useState([])
  const [makePage, setMakePage] = useState([])
  const [sumPagePrice, setSumPagePrice] = useState()
  useEffect(() => {

    let temp = [...componentData.data[0].column]
    let tempData = [...componentData.data[0].data]
    temp.unshift({
      title: "ردیف",
      field: "RF",
      headerFilter: true
    })
    temp.push({
      title: "توضیحات",
      field: "TZ",
      headerFilter: true
    })
    setMyColumn(temp)

    let flag = 1
    tempData.forEach((v) => {
      v.RF = flag
      v.YZ = ""
      flag = flag + 1
    })
    setMyData(tempData)

    if (componentData.data[0].data.length > 25) {
      let i = 0;
      let mainData = []
      let mainPrice = []
      while (i < componentData.data[0].data.length) {

        let temp = []
        let pricePage = 0
        for (let j = 0; j < 25; j++) {
          temp.push(componentData.data[0].data[i])
          pricePage = pricePage + +componentData.data[0].data[i].JAM
          i = i + 1;
          if (i === componentData.data[0].data.length) {
            break;
          }
        }
        mainData.push(temp)
        mainPrice.push(pricePage)
      }
      setMakePage(mainData)
      setSumPagePrice(mainPrice)
    } else {
      let temp = []
      temp.push(componentData.data[0].data)
      setMakePage(temp)
    }
  }, [])

  try {
    return (
      <div className="main-print-factor">

        <div className="header-side">
          <h4>{componentData.title}</h4>
        </div>

        {makePage.length > 0 && makePage.map((v, index) =>
          <>
            <div className="box-top-side">
              <div className="name-side">
                <h3>{componentData.headerAndFooter.header[5].value}</h3>
              </div>
              <div className="inline-text">
                <p>شماره فاکتور :</p>
                <p>{numericFunction.e2p(componentData.headerAndFooter.header[2].value)}</p>
              </div>

              <div className="inline-text">
                <p>نــام انبــار :</p>
                <p>{componentData.headerAndFooter.header[4].value}</p>
              </div>

              <div className="inline-text">
                <p>طرف مقابل :</p>
                <p>{numericFunction.e2p(componentData.headerAndFooter.header[3].value)}</p>
              </div>

              <div className="inline-text">
                <p>تـاریـخ :</p>
                <p>{numericFunction.e2p(componentData.headerAndFooter.header[1].value)}</p>
              </div>

              <div className="inline-text" style={{columnGap: '4px'}}>
                <p>شماره صفحه :</p>
                <p>{numericFunction.e2p(index + 1)}</p>
                <p>از</p>
                <p>{numericFunction.e2p(makePage.length)}</p>
              </div>
            </div>

            <div className="box-table-side">

              <div className="main-table-print">
                {myData.length > 0 ?
                  <DynaTable
                    column={myColumn}
                    data={v}
                    className={"DynaTable-print solid-table-print"}
                    onRowClick={""}
                    mainWidth={"100%"}
                    priceFields={componentData.data[0].priceFields}
                  /> : <p>اطلاعاتی برای نمایش وجود ندارد</p>}
              </div>

              <div className="footer-side">
                <div className="row-price">
                  {makePage[makePage.length - 1] === v ?
                    <>
                      <div className="inline-text">
                        <p>تخفیف :</p>
                        <p>{numericFunction.e2p(commaSeparator(componentData.headerAndFooter.footer[1].value))}</p>
                      </div>
                      <div className="inline-text">
                        <p>جمع کل فاکتور :</p>
                        <p>{numericFunction.e2p(commaSeparator(componentData.headerAndFooter.footer[3].value))}</p>
                      </div>
                    </> : <div className="inline-text">
                      <p>جمع فاکتور این صفحه :</p>
                      <p>{numericFunction.e2p(commaSeparator(sumPagePrice[index]))}</p>
                    </div>
                  }
                </div>
              </div>

            </div>

            <div className="footer-side">

              <div className="row-box-price">
                <div className="single-box-price">
                  <p>صادر کننده :</p>
                  <div className="date-and-emz">
                    <p>تاریخ :</p>
                    <p>امضا</p>
                  </div>
                </div>

                <div className="single-box-price" style={{borderRight: 'none', borderLeft: 'none'}}>
                  <p>مدیر مالی :</p>
                  <div className="date-and-emz">
                    <p>تاریخ :</p>
                    <p>امضا</p>
                  </div>
                </div>

                <div className="single-box-price">
                  <p>مدیر عامل :</p>
                  <div className="date-and-emz">
                    <p>تاریخ :</p>
                    <p>امضا</p>
                  </div>
                </div>
              </div>

            </div>
            {makePage[makePage.length - 1] !== v && <div style={{pageBreakBefore: "always"}}></div>}
          </>
        )}


      </div>
    );
  } catch (error) {
    return <>{error.toLocaleString()}</>
  }
};

export default PrintFactorBuySadan;